<!--
 * @Author: yangxu yangxu@staff.hexun.com
 * @Date: 2025-02-17 17:43:30
 * @LastEditors: yangxu yangxu@staff.hexun.com
 * @LastEditTime: 2025-03-13 09:32:41
 * @FilePath: /js_celue-zuhe_src/src/components/hasRight.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="tabs">
    <div
      v-for="(item, index) in tabs"
      :key="index"
      @click="changeTab(index, item.trackName)"
      :class="{ active: active == index }"
    >
      {{ item.name }}
    </div>
  </div>
  <keep-alive>
    <component :is="tabs[active].component"></component>
  </keep-alive>
</template>
<script setup>
// 从 Vue 中导入 ref 钩子
import { ref, defineAsyncComponent } from "vue";
import { useStore } from "vuex";
const store = useStore();

// 定义一个响应式的数组变量，包含所有选项卡的信息
const tabs = [
  {
    name: "组合持仓",
    trackName: "组合仓位页签",
    component: defineAsyncComponent(() => //NOSONAR
      // 导入持仓组件
      import("@/components/CombinationPosition.vue")
    ),
  },
  {
    name: "调仓明细",
    trackName: "调仓明细页签",
    component: defineAsyncComponent(() => //NOSONAR
      // 导入调仓明细组件
      import("@/components/CombinationTransfer.vue")
    ),
  },
  {
    name: "完结明细",
    trackName: "完结明细页签",
    component: defineAsyncComponent(() => //NOSONAR
      // 导入完结明细组件
      import("@/components/CombinationEnd.vue")
    ),
  },
  {
    name: "曲线收益",
    trackName: "收益曲线页签",
    component: defineAsyncComponent(() => //NOSONAR
      // 导入曲线收益组件
      import("@/components/CombinationIncome.vue")
    ),
  },
];
// 定义一个响应式的数值变量，用于存储当前激活的选项卡索引
const active = ref(0);
// 定义切换选项卡的函数
const changeTab = (index, name) => {
  // 将当前激活的选项卡索引设置为传入的索引值
  const list = store.state.detail;
  console.log(list);
  active.value = index;
  window.sensorsCustom?.sendTrack("clickSFZHDetailPage", {
    page_name: "示范账户详情页",
    special_column_name: list.product.product_name,
    special_column_id: list.product.product_id,
    partner_name: list.product.nick_name,
    partner_id: list.product.advisor_id,
    product_id: list.combination.productId,
    user_permission_status: list.user_rights[0].hasAccess ? "有权限" : "无权限",
    button_name: `${name}`,
  });
};
</script>
<style lang="scss">
.tabs {
  display: flex;
  justify-content: space-between;
  margin: calc(var(--imgfontSize) * 24) calc(var(--imgfontSize) * 30); /* 12px, 15px -> calc(var(--imgfontSize) * 24), calc(var(--imgfontSize) * 30) */

  div {
    font-size: calc(
      var(--imgfontSize) * 30
    ); /* 15px -> calc(var(--imgfontSize) * 30) */
    line-height: calc(
      var(--imgfontSize) * 72
    ); /* 36px -> calc(var(--imgfontSize) * 72) */
    width: calc(
      var(--imgfontSize) * 160
    ); /* 80px -> calc(var(--imgfontSize) * 160) */
    height: calc(
      var(--imgfontSize) * 72
    ); /* 36px -> calc(var(--imgfontSize) * 72) */
    border-radius: calc(
      var(--imgfontSize) * 36
    ); /* 18px -> calc(var(--imgfontSize) * 36) */
    background: #fff;
    text-align: center;
    color: #666;
    font-weight: 400;
  }

  .active {
    color: #ff3f33;
    font-weight: 600;
  }
}
</style>
